
import Entity from '../../entities/entity'
import Address from '../../entities/address'

export default class Customer extends Entity<number>{
    code:string;
    name: string;
    addressId:number;
    phone:string;
    taxNumber: string;
    type: string;
    receiver: string;
    customerAddress: Address=new Address();
    typeName:string;
}